export enum ApplicationPolicyEnum {
    BeveragesCluster = "beverages-cluster",
    Logimanta = "logimanta",
    CurbePostventa = "curbe-postventa",
    HondaPostVenta = "honda-post-venta",
    ChopiAssist = "chopi-assist",
    CurbeTMS = "curbe-tms"
}